<div class="ci">
  <div class="ci-lista" #lista>
    <div class="ci-vazio" *ngIf="!mensagens.length && vazio">
      <i class="pi pi-bolt"></i>
      <span>{{ vazio }}</span>
    </div>
    <ng-container *ngFor="let m of mensagens">
      <div class="ci-usuario" *ngIf="m.papel === 'usuario'">{{ m.texto }}</div>
      <div class="ci-assistente" *ngIf="m.papel === 'assistente'">
        <span class="ci-avatar"><i class="pi pi-bolt"></i></span>
        <div class="ci-corpo">
          <p>{{ m.texto }}</p>
          <div class="ci-erros" *ngIf="m.erros?.length">
            <strong>Não passou na conferência:</strong>
            <ul>
              <li *ngFor="let e of m.erros">{{ e }}</li>
            </ul>
          </div>
          <div class="ci-avisos" *ngIf="m.avisos?.length">
            <strong>Confira antes de salvar:</strong>
            <ul>
              <li *ngFor="let a of m.avisos">{{ a }}</li>
            </ul>
          </div>
          <small *ngIf="m.rodape">{{ m.rodape }}</small>
        </div>
      </div>
    </ng-container>
    <div class="ci-assistente ci-pensando" *ngIf="ocupado">
      <span class="ci-avatar"><i class="pi pi-spin pi-spinner"></i></span>
      <div class="ci-corpo"><p>Lendo o banco e montando a proposta. Pode levar até um minuto.</p></div>
    </div>
  </div>
  <div class="ci-campo">
    <label for="ci-texto">{{ rotuloCampo }}</label>
    <textarea id="ci-texto" pInputTextarea rows="3" [(ngModel)]="texto" [placeholder]="placeholder" [disabled]="ocupado" (keydown)="tecla($event)"></textarea>
    <div class="ci-linha">
      <small>Ctrl + Enter envia. A IA vê só a estrutura do banco e as fontes, nunca os dados.</small>
      <button pButton type="button" label="Enviar" icon="pi pi-send" [disabled]="ocupado || !texto.trim()" (click)="mandar()"></button>
    </div>
  </div>
</div>
